import { render, staticRenderFns } from "./T1NoOffers.vue?vue&type=template&id=2aab674a&scoped=true&"
var script = {}
import style0 from "./T1NoOffers.vue?vue&type=style&index=0&id=2aab674a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aab674a",
  null
  
)

export default component.exports